<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment" style="padding-top:150px">
<p style="text-align: center;">By Candace Therese Mezetin</p>
<br/>
<p style="text-indent:0em"><em>Brokenness was for yesterday. Today has finally come. I live healed. Healed from the silence that barricaded me from experiencing the fullness that life has to offer. Healed from the mental groanings that were resurrected from the core of my soul, never escaping, but marinating in my mind…over and over and over again. Brokenness was yesterday’s tune, but today, I sing a new song.</em></p>
<p><em><br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?5efc5377